<template>
  <div id="moves-list">
    <h2 class="title">Lista de Cruces</h2>
    <CrossingRow
      v-for="crossing in list"
      :key="crossing.movement_pkey"
      :crossing="crossing"
    />
  </div>
</template>

<script>
import CrossingRow from '@/components/Crossings/Row'
import { mapState, mapActions } from 'vuex'

export default {
  name: 'MovesList',
  components: {
    CrossingRow
  },
  data () {
    return {
      showModalSentri: false,
      titleContent: 'CRUCES RECIENTES'
    }
  },
  computed: {
    ...mapState('crossings', ['list'])
  },
  methods: {
    ...mapActions('crossings', [
      'getCrossings'
    ])
  },
  beforeMount: function () {
    this.getCrossings().then(response => {
    }).catch(_ => {
    })
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/styles/constants.scss';

#moves-list {
  margin: 1rem 2rem;
}

.title {
  text-align: start;
  color:$grey;
}
</style>
